import { IBillingProfile } from '../../types/checkout.types';
import { Box, Typography } from '@mui/material';
import React from 'react';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { useAppSelector } from 'app/hooks';
import { companyStore } from 'features/company/stores/company.slice';
import BrandCreditCardIcon from 'components/BrandCreditCardIcon';

const DisplayPaymentSelection = ({
   selectedPaymentId,
   payment,
}: {
   payment: IBillingProfile;
   selectedPaymentId?: string | null;
}) => {
   const { companyInfo } = useAppSelector(companyStore);

   return (
      <Box className={`address-label ${selectedPaymentId && selectedPaymentId === payment.id ? 'selected' : ''}`}>
         {payment.firstName && (
            <>
               <span className="shipping-address-name">
                  {payment.firstName}, {payment.lastName}
               </span>
               <br />
            </>
         )}
         {payment.address && (
            <>
               {payment.address}
               {payment.address2 ? (
                  <>
                     <br />
                     {payment.address2}
                  </>
               ) : null}
               <br />
               {payment.city}, {payment.region}, {payment.postal}
               <br />
            </>
         )}
         {companyInfo?.finixObject?.env.startsWith('stripe') ? (
            <Box display="flex" alignItems="center" component="span">
               <BrandCreditCardIcon brand={payment?.cardBrand} />
               <Typography variant="body1" ml={1}>
                  Card ending in {payment?.accountNum}
               </Typography>
            </Box>
         ) : (
            <Box display="flex" alignItems="center" mb={3} component="span">
               <CreditCardIcon fontSize="medium" />
               <Typography variant="body1" ml={1}>
                  Card ending in {payment?.accountNum}
               </Typography>
            </Box>
         )}
      </Box>
   );
};

export default DisplayPaymentSelection;
